<template>
    <div class="grouped-invoice">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="row">
                <div class="col-lg-6 col-lg-offset-3 col-sm-12">
                    <div class="pull-right hidden-print">
                        <print></print>&nbsp;
                    </div>

                    <div class="clearfix"></div>

                    <br />

                    <div class="panel panel-default">
                        <div class="panel-body">
                            <p class="lead text-center">Summary</p>

                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <td>Bookings</td>

                                        <td class="text-right">
                                            {{numberOfInvoices}} bookings
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>VAT</td>

                                        <td class="text-right">
                                            {{totalAmount * 0.20 | fixedNumber(2) | moneyFormat}},- DKK
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Subtotal</td>

                                        <td class="text-right">
                                            {{totalAmount * 0.80 | fixedNumber(2) | moneyFormat}},- DKK
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <strong>Total</strong>
                                        </td>

                                        <td class="text-right">
                                            {{totalAmount | fixedNumber(2) | moneyFormat}},- DKK
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="clearfix"></div>
                        </div>
                    </div>

                    <hr />
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6 col-lg-offset-3 col-sm-12">
                    <div v-for="reservation in reservations" :key="reservation.id">
                        <invoice :id="reservation.id"></invoice>

                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loader from '@/components/layout/Loader'
    import Invoice from '@/components/reservations/Invoice'
    import Print from '@/components/layout/Print'

    import * as ReservationService from '@/services/reservations/ReservationService'

    export default {
        data() {
            return {
                numberOfInvoices: null,
                loaded: 0,
                reservations: []
            }
        },

        computed: {
            hasLoaded() {
                return this.loaded === this.numberOfInvoices
            },

            totalAmount() {
                let total = 0

                this.reservations.forEach((reservation) => {
                    total += reservation.price
                    total += reservation.totalPriceBreakfast
                    total += reservation.totalProductPrice
                })

                return total
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                const ids = this.$router.currentRoute.query.ids.split(',')
                this.numberOfInvoices = ids.length

                ids.forEach((id) => {
                    ReservationService.find(id, {}, (response) => {
                        const reservation = response.data

                        this.reservations.push(reservation)
                        this.loaded++
                    })
                })

            }
        },

        components: {
            Loader,
            Invoice,
            Print
        }
    }
</script>


// WEBPACK FOOTER //
// GroupedInvoice.vue?69ca1859